<template>
    <div class="hidden-xl hidden-lg toolbar tabbar tabbar-labels toolbar-bottom menubar-area">
        <div class="toolbar-inner">
            <a v-on:click="$root.go('Inicio')" v-bind:class="{'active': $root.$route.name == 'Inicio'}" class="tab-link">
                <i class="las la-home" style="font-size: 30px"></i>
            </a>

            <a v-if="$root.user.tipo != 'prestador'" v-on:click="$root.go('Busca')" v-bind:class="{'active': $root.$route.name == 'Busca'}" class="tab-link">
                <i class="las la-search" style="font-size: 31px; top: 2px; position: relative;"></i>
            </a>
            <a v-on:click="$root.go('Pedidos')" v-bind:class="{'active': $root.$route.name == 'Pedidos'}" class="tab-link">
                <i class="las la-clock" style="font-size: 33px"></i>
            </a>
            <a v-if="$root.user.tipo == 'prestador'" v-on:click="$root.go('Agendas')" v-bind:class="{'active': $root.$route.name == 'Agendas'}" class="tab-link">
                <i class="las la-cog" style="font-size: 33px;"></i>
            </a>
            <a v-on:click="$root.go('Conta')" v-bind:class="{'active': $root.$route.name == 'Conta'}" class="tab-link">
                <i class="las la-user" style="font-size: 36px;"></i>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Toolbar',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue